import React from "react";
import { Route, Routes } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Switch } from "react-router-dom";
import Login from "./components/pages/Authentication";
import Register from "./components/pages/Authentication/Register";
import ForgotPassword from "./components/pages/Authentication/ForgotPassword";
import Error404 from "./components/pages/Authentication/Error-404";

import UserDashBoard from "./components/pages/Dashboard/StudentDashboard";
import ReferaFriend from "./components/pages/Oxyloans/Lender/ReferaFriend";
import Writetous from "./components/pages/Oxyloans/Lender/Writetous";
import Whatapplog from "./components/pages/Authentication/Whatapplog";
import Profile from "./components/pages/Blog/Profile";
import Program1 from "./components/pages/Dashboard/Program1";
import MyApplicationProgress from "./components/pages/Dashboard/MyApplicationProgress/MyApplicationProgress";
import MyApplicationUni from "./components/pages/Dashboard/MyApplicationProgress/MyApplicationUni";
import Applicationpage from "./components/pages/Dashboard/Applicationpage";
import ViewChat from "./components/pages/Dashboard/ViewChat/ViewChat";
import Quickapply from "./components/Quickapply";
import Normalsearch from "./components/pages/Normalsearch";
import Addvancesearch from "./components/pages/Reusecomponent/Addvancesearch/AddvanceSearch";
import ApplicationStatus from "./components/pages/Reusecomponent/ApplicationStatus";
import ProfileTab from "./components/pages/Reusecomponent/ProfileTab/ProfileTab";
import ChatUnivercity from "./components/pages/Reusecomponent/Chatsupport/ChatUnivercity";
import Quicksearch from "./components/pages/Reusecomponent/quicksearch/Quicksearch";
import Buildsop from "./components/pages/Dashboard/Applicationpage/Buildsop/Buildsop";
import BuildFilter from "./components/pages/Dashboard/Applicationpage/Buildsop/BuildFilter";
import TabFilter from "./components/pages/Dashboard/Applicationpage/Buildsop/TabFilter";
import SopTab from "./components/pages/Dashboard/Applicationpage/Buildsop/SopTab";
import UniversityChatCard from "./components/pages/Reusecomponent/UniversityChatCard/UniversityChatCard";
import ChatSupport from "./components/pages/Reusecomponent/ChatSupportUnivercity/ChatSupport";
import Adminstudentview from "./components/pages/Admin/Adminstudentview";
import UniversityApply from "./components/pages/UnivversityApply/UniversityApply";
import Singleuniversity from "./components/pages/UnivversityApply/Singleuniversity";
import Adminuniversity from "./components/pages/UnivversityApply/Adminuniversity";
import ApplyLoan from "./components/pages/Dashboard/Applyloan/ApplyLoan";
import Waitingforapproval from "./components/pages/Admin/Waitingforapproval";
import adminDashBoard from "./components/pages/Admin/adminDashBoard";
import SuperAdminDashboard from "./components/pages/Admin/SuperAdminDashboard";
import teamUseDashboard from "./components/pages/Team User/teamUseDashboard";
import PrivateRoute from "./components/pages/Authentication/PrivateRoute";
import ErrorPage from "./components/pages/Dashboard/ErrorPage";
import Error500 from "./components/pages/ErrorMessage/Error500";
import AllStudents from "./components/pages/Admin/AllStudents";
import WishListChatCard from "./components/pages/Reusecomponent/WishLIstChatCard/WishListChatCard";
import Popup from "./components/pages/Reusecomponent/Popup";
import ProfileShortlisting from "./components/pages/Reusecomponent/profileShortListing";


import Sopcomponent from "./components/pages/Dashboard/Applicationpage/Buildsop/Sopcomponent";

import ProfileShortList from "./components/pages/Admin/showProfileShortlisting";
import MyForm from "./components/pages/Reusecomponent/UniversityShortlistingProfile";

import ConsultancyHome from "./components/pages/Consultancy/Home/ConsultancyHome";
import DestinationsPage from "./components/pages/Consultancy/Destinations/DestinationsPage";
import DestinationDetailPage from "./components/pages/Consultancy/Destinations/DestinationDetailPage";
import UniversitiesPage from "./components/pages/Consultancy/Universities/UniversitiesPage";
import UniversityDetailPage from "./components/pages/Consultancy/Universities/UniversityDetailPage";
import CoursesPage from "./components/pages/Consultancy/Courses/CoursesPage";
import ScholarshipsPage from "./components/pages/Consultancy/Scholarships/ScholarshipsPage";
import ServicesPage from "./components/pages/Consultancy/Services/ServicesPage";
import AboutPage from "./components/pages/Consultancy/About/AboutPage";
import SuccessStoriesPage from "./components/pages/Consultancy/SuccessStories/SuccessStoriesPage";
import BlogPage from "./components/pages/Consultancy/Blog/BlogPage";
import BlogDetailPage from "./components/pages/Consultancy/Blog/BlogDetailPage";
import ContactPage from "./components/pages/Consultancy/Contact/ContactPage";
import BookConsultationPage from "./components/pages/Consultancy/Consultation/BookConsultationPage";
import "./components/pages/Consultancy/ConsultancyStyles.css";

import BookDeal from "./components/pages/Dashboard/Deals/BookDeal";
import BookDealcopy from "./components/pages/Dashboard/Deals/BookDealcopy";

import DiscountSlider from "./components/pages/Dashboard/Deals/DiscountSlider";
import WishList from "./components/pages/Reusecomponent/WishLIstChatCard/WishList";
import Stepline from "./components/pages/Reusecomponent/StepLine/Stepline";

import Issues from "./components/pages/Admin/issues";
import StudentCopy from "./components/pages/Admin/StudentCopy";

import MyTable from "./components/pages/Admin/deals";
import LeadsData from "./components/pages/Admin/LeadsData";

import UniversityChatCardComponent from "./components/pages/Reusecomponent/UniversityChatCard/UniversityChatCard";
import UniversityChatComponent from "./components/pages/Reusecomponent/UniversityChatCard/UniversityChatComponent";
import LoanApplications from "./components/pages/Admin/LoanApplications";





const appcontainer = () => {
  return (
    <Router Router basename="/">
      <Switch>
        {/* MAIN PUBLIC CONSULTANCY HOMEPAGE & AUTH ROUTES */}
        <Route exact path="/" component={ConsultancyHome} />
        <Route path="/login" component={Login} />
        <Route path="/register" component={Register} />
        <Route path="/forgotpassword" component={ForgotPassword} />

        {/* OVERSEAS EDUCATION CONSULTANCY PLATFORM ROUTES */}
        <Route exact path="/consultancy" component={ConsultancyHome} />
        <Route exact path="/consultancy/destinations" component={DestinationsPage} />
        <Route path="/consultancy/destinations/:countryId" component={DestinationDetailPage} />
        <Route exact path="/consultancy/universities" component={UniversitiesPage} />
        <Route path="/consultancy/universities/:uniId" component={UniversityDetailPage} />
        <Route path="/consultancy/courses" component={CoursesPage} />
        <Route path="/consultancy/scholarships" component={ScholarshipsPage} />
        <Route path="/consultancy/services" component={ServicesPage} />
        <Route path="/consultancy/about" component={AboutPage} />
        <Route path="/consultancy/success-stories" component={SuccessStoriesPage} />
        <Route exact path="/consultancy/blog" component={BlogPage} />
        <Route path="/consultancy/blog/:postId" component={BlogDetailPage} />
        <Route path="/consultancy/contact" component={ContactPage} />
        <Route path="/consultancy/book-consultation" component={BookConsultationPage} />
        <PrivateRoute path="/profiletab" component={ProfileTab} />
        <Route path="/error404" component={Error404} />
        <PrivateRoute path="/dashboard" component={UserDashBoard} />
        <PrivateRoute path="/admindashboard" component={adminDashBoard} />
        <PrivateRoute path="/superadmin" component={SuperAdminDashboard} />
        <PrivateRoute path="/teamdashboard" component={teamUseDashboard} />
        <PrivateRoute path="/viewchat" component={ViewChat} />
        <PrivateRoute path="/quicksearch" component={Quicksearch} />
        <PrivateRoute path="/addvancesearch" component={Addvancesearch} />
        <PrivateRoute path="/applyloan" component={ApplyLoan} />
        <PrivateRoute path="/buildFilter" component={BuildFilter} />
        <PrivateRoute path="/profileShortlisting" component={ProfileShortList} />
        <PrivateRoute path="/buildsop" component={Buildsop} />
        <PrivateRoute path="/soptab" component={SopTab} />

        <PrivateRoute path="/bookdeal" component={BookDeal} />    
        <PrivateRoute path="/bookdealcopy" component={BookDealcopy} />
        
        <PrivateRoute path="/discountslider" component={DiscountSlider} />
        <PrivateRoute path="/sopcomponent"  component={Sopcomponent}  />

        <PrivateRoute path="/test1" component={MyForm} />

        <PrivateRoute path="/universitychatcard" component={UniversityChatCard} />
        <PrivateRoute path="/issues" component={Issues} />
        <PrivateRoute path="/admindeals" component={MyTable} />

        <PrivateRoute path="/wishlistchatcard" component={WishListChatCard} />
        <PrivateRoute path="/modalpopup" component={Popup} />
        <PrivateRoute path="/profileshortlisting" component={ProfileShortlisting} />
        <PrivateRoute path="/tabfilter" component={TabFilter} />
        {/* `` */}

        <PrivateRoute path="/bookdeal" component={BookDeal} />  
          <PrivateRoute path="/bookdealcopy" component={BookDealcopy} />
          <PrivateRoute path="/leadsData" component={LeadsData} />

        
        <PrivateRoute path="/myApplications" component={UniversityChatComponent} />
        <PrivateRoute path="/discountslider" component={DiscountSlider} />
        <PrivateRoute path="/chatunivercity" component={ChatUnivercity} />
        <PrivateRoute path="/profile" component={ProfileTab} />
        {/* <Route path="/profile" component={Profile} />      */}
        <PrivateRoute path="/wishList" component={WishList} />
        <PrivateRoute path="/applicationpage1" component={Applicationpage} />
        <PrivateRoute path="/adminstudentview" component={Adminstudentview} />
        <PrivateRoute path="/stepline" component={Stepline} />
        <PrivateRoute path="/applicationstatus" component={ApplicationStatus} />
        <PrivateRoute path="/writetous" component={Writetous} />  
        <PrivateRoute path="/programfinder" component={Program1} />
        <PrivateRoute path="/chatSupport" component={ChatSupport} />
        <PrivateRoute path="/myapplicationprogress" component={MyApplicationProgress} />
        <PrivateRoute path="/normalsearch" component={Normalsearch} />
        <PrivateRoute path="/referaFriend" component={ReferaFriend} />
        <PrivateRoute path="/universitydetails" component={Singleuniversity} />
        <PrivateRoute path="/allstudents" component={AllStudents} />
        <PrivateRoute path="/loanapplications" component={LoanApplications} />

        <PrivateRoute path="/universityapply" component={UniversityApply} />
        {/* <PrivateRoute path="/errorcode" component={Error404} />
        <PrivateRoute path="/errorcode500" component={Error500} />
        <Route component={ErrorPage} /> */}


        {/* <Route path="/myreferalStatus" component={MyreferalStatus} /> */}
        {/* <Route path="/myEarnings" component={MyEarnings} /> */}


      
        <PrivateRoute
          path="/myapplicationuni"
          component={MyApplicationUni}
        />

<PrivateRoute
  path="/adminuniversity"
  component={Adminuniversity}
/>     
<PrivateRoute path="/studentCopy" component={StudentCopy} />
        <PrivateRoute
          path="/waitingforapproval"
          component={Waitingforapproval}
        />
        <PrivateRoute
          path="/quickapply"
          component={Quickapply}
        />
        <PrivateRoute path="/whatapplogin" component={Whatapplog} />
        {/* 
        oxyroutes End */}
      </Switch>
    </Router>
  );
};

export default appcontainer;
